/** Official Takshify contact channels (keep in sync with takshify.school). */
export const brandContact = {
  email: 'takshifyschool@gmail.com',
  youtubeHandle: '@takshifyschool',
  youtubeUrl: 'https://www.youtube.com/@takshifyschool',
  youtubeBrandRed: '#FF0000',
} as const;

export const siteFooterCopy = {
  tagline: 'The Digital Takshashila',
  sanskrit: 'सर्वे भवन्तु सुखिनः',
  emailUs: 'Email us',
  youtubeChannel: 'YouTube',
  copyright: (year: number) =>
    `© ${year} Takshify™ · A product of Vaitri Technologies (OPC) Pvt. Ltd.`,
} as const;
